module.exports = __webpack_public_path__ + "static/media/vail.136069c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/assets/vail.png
// module id = 543
// module chunks = 0